import revive_payload_client_4sVQNw7RlN from "/app/browser/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/browser/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/browser/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/browser/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/browser/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/browser/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/browser/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/browser/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/browser/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/browser/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_WLsn00x1qh from "/app/browser/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import nuxt_plugin_6wEQMY3tee from "/app/browser/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import plugin_client_4F1kZh3YAB from "/app/browser/node_modules/nuxt-viewport/dist/runtime/plugin.client.js";
import i18n_yfWm7jX06p from "/app/browser/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import axios_Ad5h5RE3ZU from "/app/browser/modules/backend/plugins/axios.ts";
import fetch_Ez5pypKMDT from "/app/browser/modules/backend/plugins/fetch.ts";
import seo_meta_DXAielwcUN from "/app/browser/plugins/seo-meta.ts";
import marketing_tracking_YfLF4CwZGQ from "/app/browser/plugins/marketing-tracking.ts";
import error_handler_kEP5FliEXj from "/app/browser/plugins/error-handler.ts";
import vue_datepicker_dyozMmv23j from "/app/browser/plugins/vue-datepicker.ts";
import vue_google_tag_manager_client_K6MPWtDZHs from "/app/browser/plugins/vue-google-tag-manager.client.ts";
import plugin_client_QHzhVBB2Ll from "/app/browser/.nuxt/nuxt-booster/plugin.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_WLsn00x1qh,
  nuxt_plugin_6wEQMY3tee,
  plugin_client_4F1kZh3YAB,
  i18n_yfWm7jX06p,
  axios_Ad5h5RE3ZU,
  fetch_Ez5pypKMDT,
  seo_meta_DXAielwcUN,
  marketing_tracking_YfLF4CwZGQ,
  error_handler_kEP5FliEXj,
  vue_datepicker_dyozMmv23j,
  vue_google_tag_manager_client_K6MPWtDZHs,
  plugin_client_QHzhVBB2Ll
]